import React from "react";
import { useState } from "react";
import "./index.css";
import profileImg from "../../assets/images/dashboard/editProfile.jpg";
import cameraImg from "../../assets/images/dashboard/camera.png";

export const Account = () => {
  const [profileImgPreview, setProfileImgPreview] = useState(profileImg);
  return (
    <div className="accountContainer">
      <div className="personalText">Personal Information:</div>
      <form>
       <div className="editProfileImgWrapper">
  <div className="editProfileImg">
    <img src={profileImgPreview} alt="Profile" />
    <div className="cameraImgContainer">
      <label htmlFor="cameraImg">
        <img src={cameraImg} alt="Camera Icon" />
      </label>
      <input
        type="file"
        id="cameraImg"
        accept="image/*"
        style={{ display: "none" }}
        onChange={(e) => {
          const file = e.target.files[0];
          if (file) {
            const imageUrl = URL.createObjectURL(file);
            setProfileImgPreview(imageUrl);
          }
        }}
      />
    </div>
  </div>
</div>

        <div className="inputGrid">
          <div className="profileInput">
            <label>Full Name</label>
            <div>
              {" "}
              <input type="text" placeholder="Enter Full Name" />
            </div>
          </div>
          <div className="profileInput">
            <label>Email</label>
            <div>
              <input type="email" placeholder="Enter Email" />
            </div>
          </div>
          <div className="profileInput">
            <label>Mobile Number</label>
            <div>
              <input type="text" placeholder="Enter Mobile Number" />
            </div>
          </div>
        </div>
        <div className="inputGrid">
          <div className="profileInput">
            <label>Aadhaar Number</label>
            <div>
              {" "}
              <input type="text" placeholder="Enter Aadhaar Number" />
            </div>
          </div>
          <div className="profileInput">
            <label>PAN Number</label>
            <div>
              <input type="text" placeholder="Enter PAN Number" />
            </div>
          </div>
          <div className="profileInput">
            <label>Password </label>
            <div>
              <input type="password" placeholder="Enter Password" />
            </div>
          </div>
        </div>
        <div className="inputGrid">
          <div className="profileInput">
            <label>Interests</label>
            <div>
              <select>
                <option>Select</option>
                <option>---</option>
              </select>
            </div>
          </div>
        </div>
        <div className="btnUpdate">
          <button>Update Changes</button>
        </div>
      </form>
    </div>
  );
};
